import {
  deleteReportEndpoint,
  downloadReportEndpoint,
  getReportsListEndpoint,
  prepareReportEndpoint,
} from "./api/Report";

export const prepareReport = async (reportPayload, digitalTwinId) => {
  try {
    const response = await prepareReportEndpoint(reportPayload, digitalTwinId);
    return response;
  } catch (error) {
    throw new Error(`Error generating report: ${error.message}`);
  }
};

export const downloadReport = async (patientId, fileName) => {
  try {
    await downloadReportEndpoint(patientId, fileName);
  } catch (error) {
    throw new Error(`Error downloading report: ${error.message}`);
  }
};

export const deleteReport = async (patientId, fileName) => {
  try {
    const response = await deleteReportEndpoint(patientId, fileName);
    return response;
  } catch (error) {
    throw new Error(`Error deleting report: ${error.message}`);
  }
};

export const getReportsList = (patientId, signal) =>
  getReportsListEndpoint(patientId, signal);
